import {Subject, timer} from 'rxjs';
import {OverlayRef} from '@angular/cdk/overlay';
import {TemplateRef, Type} from '@angular/core';

export interface DialogCloseEvent<R> {
  type: 'backdropClick' | 'close';
  data: R;
}

export class DialogRef<R = any, T = any> {
  afterClosed$ = new Subject<DialogCloseEvent<R | null | undefined>>();

  closing = false;

  constructor(
    public overlay: OverlayRef,
    public content: string | TemplateRef<any> | Type<any>,
    public data: T,
  ) {
    overlay.backdropClick().subscribe(() => this._close('backdropClick', null));
  }

  close(data?: R) {
    this.closing = true;
    timer(320).subscribe(() => this._close('close', data));
  }

  private _close(type: 'backdropClick' | 'close', data: R | null | undefined) {
    this.overlay.dispose();
    this.afterClosed$.next({
      type,
      data,
    });

    this.afterClosed$.complete();
  }
}
